import { useEffect } from 'preact/hooks'
import { useLocation } from 'wouter'
import { Loading } from '../../components/Loading'
import { useAuth } from '../../hooks/useAuth'
import { ROUTES } from '../../routes'
import { cleanInviteFromUrl, extractInviteFromUrl } from '../../services/keycloak'
import { storeInviteCode } from './LandingPage'

export function CallbackPage() {
  const { isInitialized, isAuthenticated, hasProfile, isLoading, login } = useAuth()
  const [, setLocation] = useLocation()

  // Extract invite code from URL immediately on mount
  // This runs before auth check to ensure we capture the code
  useEffect(() => {
    const urlInvite = extractInviteFromUrl()
    if (urlInvite) {
      // URL params take priority over sessionStorage (cross-device flow)
      storeInviteCode(urlInvite.code, urlInvite.kind)
      // Clean URL for security (removes from browser history)
      cleanInviteFromUrl()
    }
  }, [])

  useEffect(() => {
    // Wait for auth to initialize
    if (!isInitialized.value || isLoading.value) return

    // Check for pending guardian link token
    const pendingToken = sessionStorage.getItem('pendingGuardianToken')
    if (pendingToken) {
      sessionStorage.removeItem('pendingGuardianToken')
      setLocation(`${ROUTES.GUARDIAN_LINK_RESOLVE}?token=${pendingToken}`)
      return
    }

    // Determine where to redirect
    if (!isAuthenticated.value) {
      // Not logged in yet (e.g., after actions-email). Trigger login to get an auth code.
      login()
      return
    }

    if (!hasProfile.value) {
      // Authenticated but no profile - go to signup
      setLocation(ROUTES.SIGNUP)
    } else {
      // Fully set up - go to game
      setLocation(ROUTES.PLAY)
    }
  }, [isInitialized.value, isAuthenticated.value, hasProfile.value, isLoading.value])

  return <Loading fullScreen message="Completing login..." />
}
